export default "__VITE_ASSET__UxGL_vv1__"